import { GradientText } from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter'
import { getHistoriqueChauffeurByMissionId } from '../../api/commande'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import DetailsChauffeurModal from '../../Components/DetailsChauffeur/DetailsChauffeurModal'
import toast from 'react-hot-toast'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next'
function HistoriqueChauffeurMission() {
    const history = useHistory()
    const { id } = useParams()
    const transporter = useSelector((state) => state.auth.user)
    const token = useSelector((state) => state.auth.token);
    const [chargementEnCours, setChargementEnCours] = useState(false);
    const [data, setData] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
    const [selectedChauffeur, setSelectedChauffeur] = useState(null)
    const { t } = useTranslation()
    const fetchData = async (page, perPage) => {
        setChargementEnCours(true)
        try {
            const res = await getHistoriqueChauffeurByMissionId(id, transporter._id, token, page, perPage)
            setData(res.docs)
            setTotalRows(res.totalDocs)
        } catch (error) {
            toast.error(t("transfer_request_err"), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setChargementEnCours(false)

        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        fetchData(page, perPage)

    }
    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(page, newPerPage)
        setPerPage(newPerPage)
    }
    const columns = [

        {
            name: "Ancien Chauffeur",
            sortable: false,
            cell: (row) => (
                <div
                    onClick={() => {
                        setModalIsOpenDetail(true)
                        setSelectedChauffeur(row.ancienChauffeurId._id)
                    }}
                    style={{
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#51C7F2'
                    }}
                >
                    {row.ancienChauffeurId && `${row.ancienChauffeurId.first_name} ${row.ancienChauffeurId.last_name}`}
                </div>
            ),

        },
        {
            name: "Nouveau Chauffeur",
            sortable: false,
            cell: (row) => (
                <div
                    onClick={() => {
                        setModalIsOpenDetail(true)
                        setSelectedChauffeur(row.nouveauChauffeurId._id)
                    }}
                    style={{
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#51C7F2'
                    }}
                >
                    {row.nouveauChauffeurId && `${row.nouveauChauffeurId.first_name} ${row.nouveauChauffeurId.last_name}`}
                </div>
            ),
        },
        {
            name: t("mission_status"),
            selector: (row) => row.statut === 'init' ? t("not_started") : row.statut === 'en-cours' ? t("in_progress") : row.statut === 'terminer' ? t("completed") : t("cancelled"),
            sortable: false,
            width: "170px"
        },
        {
            name: t("distance_traveled"),
            selector: (row) => row.distance ? row.distance : '0',
            sortable: false,
            width: "170px"
        },
        {
            name: t("note"),
            selector: (row) => row.remarque,
            sortable: false,
            width: "170px"
        },

        {
            name: t("date_of_change"),
            selector: (row) => moment(row.dateChangement).format('DD/MM/YYYY'),
            sortable: false,
        }


    ]
    useEffect(() => {
        fetchData(currentPage, perPage)

    }, [])
    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 1024);


    useEffect(() => {
        const checkIfMobile = () => {
            setSmallScreen(window.innerWidth < 1024);
        };
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <LayoutTransporter>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: '2rem',
                    paddingBottom: '4rem',
                    fontFamily: 'Montserrat',
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '2rem'
                    }}
                >
                    <div
                        onClick={() => {
                            history.goBack()
                        }}
                        style={{
                            background: '#51C7F2',
                            width: isSmallScreen ? '1.5rem' : '3rem',
                            height: isSmallScreen ? '1.5rem' : '3rem',
                            borderRadius: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={14.017}
                            height={14.11}
                            viewBox='0 0 14.017 14.11'

                        >
                            <g
                                data-name='Group 11287'
                                fill='none'
                                stroke='#fff'
                                strokeWidth={2}
                            >
                                <path
                                    data-name='Path 11687'
                                    d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232'
                                    transform='translate(-8.838 -11.113)'
                                />
                                <path
                                    data-name='Path 11688'
                                    d='M22.147 11.818l-6.348 6.349 6.348 6.348'
                                    transform='translate(-8.838 -11.113)'
                                />
                            </g>
                        </svg>
                    </div>

                    <div
                        style={{
                            width: '1rem',
                        }}
                    />

                    <GradientText marginTop={'unset'} style={{
                        fontSize: isSmallScreen ? '1.5rem' : '2.5rem'
                    }}>
                        {t("drivers_history").toUpperCase()}
                    </GradientText>
                </div>
                {chargementEnCours ?
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'white',
                            marginTop: "10rem"
                        }}
                    >
                        <div className='customLoader'></div>
                    </div>
                    : isSmallScreen ?
                        data.map((historique) => {
                            return <div style={{
                                width: '100%',
                                background: '#E4EAF0',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '1rem',
                                borderRadius: 10,
                                alignItems: 'flex-start',
                                marginBottom: 10,
                            }}>
                                <div style={{
                                    fontWeight: 'bolder',
                                    color: '#1C63C5',
                                    fontSize: '1rem',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    marginBottom: '1rem',
                                    gap: '1rem'
                                }}>
                                    <span onClick={() => {
                                        setModalIsOpenDetail(true)
                                        setSelectedChauffeur(historique.ancienChauffeurId._id)
                                    }}>{historique.ancienChauffeurId.first_name}{' '}{historique.ancienChauffeurId.last_name} </span>
                                    <ArrowForwardIcon />
                                    <span onClick={() => {
                                        setModalIsOpenDetail(true)
                                        setSelectedChauffeur(historique.nouveauChauffeurId._id)
                                    }}>{historique.nouveauChauffeurId.first_name}{' '}{historique.nouveauChauffeurId.last_name} </span>

                                </div>

                                <span style={{
                                    color: '#838EAB',
                                    fontSize: '0.9rem',
                                    marginBottom: '0.8rem',
                                }}>
                                    {t("mission_status")}:{' '}
                                    <span style={{
                                        fontSize: '0.9rem',
                                        fontWeight: 'bolder',
                                    }}>{historique.statut === 'init' ? t("not_started") : historique.statut === 'en-cours' ? t("in_progress") : historique.statut === 'terminer' ? t("completed") : t("cancelled")}</span>
                                </span>
                                <span style={{
                                    color: '#838EAB',
                                    marginBottom: '0.8rem',
                                    fontSize: '0.9rem',
                                }}
                                >{t("distance_traveled")}:{' '}
                                    <span style={{
                                        color: '#838EAB',
                                        fontWeight: 'bolder',
                                        fontSize: '0.9rem'
                                    }}>{historique.distance ? historique.distance : '0'}</span>
                                </span>
                                <span style={{
                                    color: '#838EAB',
                                    marginBottom: '0.8rem',
                                    fontSize: '0.9rem',
                                }}
                                >{t("note")}:{' '}
                                    <span style={{
                                        color: '#838EAB',
                                        fontWeight: 'bolder',
                                        fontSize: '0.9rem'
                                    }}>{historique.remarque}</span>
                                </span>
                                <span style={{
                                    color: '#838EAB',
                                    marginBottom: '0.8rem',
                                    fontSize: '0.9rem',
                                }}
                                >{t("date_of_change")}:{' '}
                                    <span style={{
                                        color: '#838EAB',
                                        fontWeight: 'bolder',
                                        fontSize: '0.9rem'
                                    }}>{moment(historique.dateChangement).format('DD/MM/YYYY')}</span>
                                </span>
                            </div>
                        }) :
                        <div
                            style={{
                                width: '100%',
                                padding: '0 1rem',
                                marginTop: '5rem'
                            }}
                        >
                            <DataTable
                                columns={columns}
                                data={data}
                                progressPending={chargementEnCours}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                noDataComponent={t("no_drivers")}
                                progressComponent={
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'white',
                                            marginTop: "10rem"
                                        }}
                                    >
                                        <div className='customLoader'></div>
                                    </div>
                                }
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Rangs par page',
                                    rangeSeparatorText: 'sur',
                                }}
                            />
                        </div>
                }
            </div>
            <DetailsChauffeurModal
                isOpen={modalIsOpenDetail}
                onClose={() => setModalIsOpenDetail(false)}
                chauffeurId={selectedChauffeur}
            />
        </LayoutTransporter>
    )
}

export default HistoriqueChauffeurMission